import {
  CurrencyAmount,
  CurrencyCode,
  CurrencyCodes,
  normalizeCurrencyCode,
  PAYROLL_CURRENCY_CODES
} from '../../models/payroll-currency.model';
import {
  TOOLTIP_TYPES,
  TooltipType
} from './my-working-report.constants';
import { ReportCurrencySummary } from './my-working-report.types';

export class MyWorkingReportCurrencyMapper {
  public mapCurrencyAmounts(summary: ReportCurrencySummary): void {
    summary.displayCurrency = normalizeCurrencyCode(summary.primaryCurrency);
    summary.orderedWageRateAmounts = this.resolve(summary, TOOLTIP_TYPES.WAGE_RATE);
    summary.orderedSalaryAmounts = this.resolve(summary, TOOLTIP_TYPES.SALARY_SUPPLEMENTS);
  }

  private resolve(summary: ReportCurrencySummary, type: TooltipType): CurrencyAmount[] {
    const amounts = type === TOOLTIP_TYPES.WAGE_RATE
      ? summary.wageRateAmounts
      : summary.salaryAmounts;
    const resolvedAmounts = amounts && amounts.length
      ? amounts
      : this.buildLegacyAmounts(summary, type);
    return this.orderAmounts(resolvedAmounts, summary.displayCurrency);
  }

  private orderAmounts(
    amounts: CurrencyAmount[],
    primaryCurrency: CurrencyCode
  ): CurrencyAmount[] {
    const order = [primaryCurrency].concat(PAYROLL_CURRENCY_CODES.filter(currency => {
      return currency !== primaryCurrency;
    }));
    return order
      .map(currency => amounts.find(amount => amount.currency === currency))
      .filter(amount => !!amount);
  }

  private buildLegacyAmounts(
    summary: ReportCurrencySummary,
    type: TooltipType
  ): CurrencyAmount[] {
    const isWage = type === TOOLTIP_TYPES.WAGE_RATE;
    return [
      { currency: CurrencyCodes.BYN, amount: isWage ? summary.wageRate : summary.salarySupplements },
      { currency: CurrencyCodes.USD, amount: isWage ? summary.wageRetainCurrency : summary.salarySupplementsCurrency },
      { currency: CurrencyCodes.EUR, amount: isWage ? summary.wageRetainCurrencyEur : summary.salarySupplementsCurrencyEur },
      { currency: CurrencyCodes.CNY, amount: isWage ? summary.wageRetainCurrencyCny : summary.salarySupplementsCurrencyCny }
    ];
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-currency.mapper.ts